import type { ResumeData } from './resume.types';

export const resumeData: ResumeData = {
  name: 'Alex Appadurai',
  title: 'Tech Lead / Mobile Software Engineer',
  tagline: 'React Native · Flutter · 13+ years · 150+ mobile applications shipped',
  profile:
    'Mobile Software Engineer with 13+ years designing, building, and deploying high-performance iOS, macOS, and Android applications. Expert in TypeScript, Swift, Objective-C, SwiftUI, React Native, and Flutter. Strong grasp of system architecture, UI/UX, RESTful APIs, Agile/Scrum, unit testing, and performance optimization. Experienced in AI-assisted development, LangChain/RAG, automated testing, and CI/CD. Passionate about scalable software and user-first design.',
  contact: {
    email: 'alexappadurai@gmail.com',
    phone: '+91 9751519188',
    location: 'Chennai',
    linkedIn: 'https://linkedin.com/in/alexappadurai',
  },
  keyPoints: [
    'AI + Cursor',
    'Spec-driven development (SDD)',
  ],
  about:
    'I have strong knowledge in mobile application development with 13+ years of experience. Solid architectural skills and hands-on experience across iOS, Android, and cross-platform apps. Experienced in deploying to App Store and enterprise distribution, handling multiple projects, and working with version control and CI/CD. Proficient in Test Driven Development, clear communication, and working as a versatile team player. 150+ mobile applications delivered.',
  contactAddress: 'Chennai, India',
  stats: [
    { label: 'Years experience', value: '13+' },
    { label: 'Apps shipped', value: '150+' },
    { label: 'iOS apps', value: '125+' },
    { label: 'Android apps', value: '15' },
    { label: 'macOS apps', value: '5' },
  ],
  services: [
    {
      id: 'ios',
      title: 'iOS Development',
      description:
        'Functional requirement analysis, architecture design, and stable native iOS and macOS applications. Swift, Objective-C, SwiftUI.',
    },
    {
      id: 'android',
      title: 'Android Development',
      description:
        'Native Android development and cross-platform delivery. Functional analysis and performance-focused mobile applications.',
    },
    {
      id: 'react-native',
      title: 'React Native',
      description:
        'From requirements to documented design and implementation. Cross-platform apps with TypeScript and modern tooling.',
    },
    {
      id: 'consultancy',
      title: 'Consultancy',
      description:
        'Consulting on mobile strategy, architecture, and development for performant, smooth user experiences.',
    },
  ],
  workStats: [
    { value: '150+', label: 'Apps Done' },
    { value: '13+', label: 'Years Experience' },
    { value: '125+', label: 'iOS Apps' },
    { value: '15', label: 'Android Apps' },
  ],
  experience: [
    {
      id: 'brightinsight',
      company: 'BrightInsight',
      role: 'Senior Software Engineer',
      period: 'Aug 2022 – Present',
      highlights: [
        'Independently develop and deliver end-to-end mobile features with high code quality.',
        'Collaborate on product development, translating business requirements into scalable, user-centric solutions.',
      ],
    },
    {
      id: 'htc',
      company: 'HTC Holdings Private Limited',
      role: 'Lead Mobile Software Engineer',
      period: 'July 2020 – Aug 2022',
      highlights: [
        'Led end-to-end product development: architecture design, coding, and deployment.',
        'Conducted code reviews, design documents, and technical documentation.',
        'Led native and cross-platform apps in fintech, e-commerce, healthcare, and streaming.',
        'Mentored junior engineers and enforced engineering best practices.',
      ],
    },
    {
      id: 'ionixx',
      company: 'Ionixx Technologies Private Limited',
      role: 'Lead Mobile Software Engineer',
      period: 'Nov 2016 – Mar 2020',
      highlights: [
        'Collaborated with UI/UX, backend, and QA for seamless product delivery.',
        'Project management, team leadership, and cross-functional teamwork.',
        'Technical documentation, performance optimization, and unit testing.',
      ],
    },
    {
      id: 'timesofmoney',
      company: 'TimesOfMoney',
      role: 'Senior Software Engineer',
      period: 'June 2016 – Oct 2016',
      highlights: [
        'Delivered secure, high-performance financial solutions with cross-functional teams.',
      ],
    },
    {
      id: 'vitruvian',
      company: 'Vitruvian Technologies Private Limited',
      role: 'Senior Software Engineer',
      period: 'Mar 2015 – May 2016',
      highlights: [
        'Delivered RSquare, Agent Search with offline support.',
        'Owned end-to-end delivery: requirements, design, development, deployment.',
      ],
    },
    {
      id: 'blisslogix',
      company: 'Blisslogix Technologies Private Limited',
      role: 'Senior Software Engineer',
      period: 'Dec 2012 – Feb 2015',
      highlights: [
        'Developed enterprise iOS apps (Leads On-The-Go, Catalog) with performance and scalability.',
        'Integrated Salesforce CRM and payment gateways for secure, real-time transactions.',
        'Contributed to architecture, coding, testing, and release management.',
      ],
    },
  ],
  technicalSkills: [
    {
      title: 'Mobile & cross-platform',
      items: ['Swift', 'Objective-C', 'React Native', 'Flutter (Dart)', 'Java', 'SwiftUI'],
    },
    {
      title: 'Languages & tools',
      items: ['TypeScript', 'JavaScript', 'Python', 'CoreData'],
    },
    {
      title: 'AI & automation',
      items: ['LangChain', 'RAG', 'AI unit test generation', 'LangChain RAG chatbot'],
    },
    {
      title: 'DevOps & quality',
      items: ['GitHub Actions', 'CI/CD', 'Code quality checks', 'Mobile app deployment'],
    },
  ],
  additionalSkills: [
    'Project Management',
    'Team Leadership & Mentoring',
    'Cross-Functional Collaboration',
    'Technical Documentation & Design',
    'Analytical & Critical Thinking',
    'Performance Optimization & Debugging',
    'Unit Testing & Quality Assurance',
  ],
  education: [
    {
      id: 'csi',
      institution: 'Jayaraj Annapackiam CSI College of Engineering, Nazareth',
      degree: 'B.Tech (Information Technology)',
      period: '2008 – 2012',
    },
    {
      id: 'concordia',
      institution: 'Concordia Higher Secondary School, Vallioor',
      degree: 'Tamil Nadu State Board',
      period: '2007 – 2008',
    },
  ],
  languages: ['English (Fluent)', 'Tamil (Native)'],
};
